import moment from "moment";
import { RootState } from "../root-reducer";
import {
  FlatItem,
  ApiFlatItem,
  ChildFlatItem,
  ApiChildFlatItem,
} from "../../types/general";
import { AllClaims } from "../../types/claim";
import { AllPlans } from "../../types/plan";
import { ClaimItem } from "../../types/claim-item";
import { Damage } from "../../types/damage";
import { UploadedFile } from "../../types/uploaded-file";
import { navigateTo } from "../../helper";
import queryString from "query-string";
import RouteNames from "../../routes/type";
import { coreStore } from "..";

export const mapApiFlatData = (payload: ApiFlatItem): FlatItem => ({
  id: payload?.id || payload?.ID,
  name: payload.name || payload.NAME,
});

export const mapApiChildFlatData = (
  payload: ApiChildFlatItem
): ChildFlatItem => ({
  id: payload?.id || payload?.ID,
  name: payload.name || payload.NAME,
  parrentId: payload.Parent_Type_ID,
});

export const getPlans = (state: RootState): AllPlans[] => state.user.plans;
export const getClaims = (state: RootState): AllClaims[] => state.user.claims;

export const mapApiClaimItem = (payload: unknown): ClaimItem => {
  return {
    id: +payload?.["item_id"],
    warrntyItemId: +payload?.["warr_item_id"],
    type: { id: payload["item_type"], name: payload["item_type_disp"] },
    manufacturer: {
      id: payload["manufact_id"],
      name: payload["manufact_disp"],
    },
    material: { id: payload["material_id"], name: payload["material_id_disp"] },
    color: { id: payload["color_id"], name: payload["color_disp"] },
    documents_and_photos: [],
    damages: Array.isArray(payload["damages"])
      ? payload["damages"].map(MapApiDamage)
      : [],
  };
};

export const MapApiDamage = (payload): Damage => {
  return {
    id: +payload["damage_id"],
    damageCategory: {
      id: payload["damage_type"],
      name: payload["damage_type_disp"],
    },
    specificLocation: {
      id: payload["specific_location"],
      name: payload["specific_location_disp"],
    },
    specificDamage: {
      id: payload["specific_damage"],
      name: payload["specific_damage_disp"],
    },
    damageDate: payload["da_damage_date"]
      ? moment(payload["da_damage_date"], "YYYY-MM-DD").toDate()
      : null,
    occuredReason: {
      id: payload["how_did_occur"],
      name: payload["how_did_occur_disp"],
    },
    actionTaken: {
      id: payload["actions_taken"],
      name: payload["actions_taken_disp"],
    },
    notes: payload["note_damage_area"],
  };
};

export const getItemType = (fileName) => {
  const ext = fileName.split(".").pop() || "";
  return ext.toLowerCase() === "pdf" ? "pdf" : "3003";
};

export const nextStepRedirect = (step, extarProps = {}) => {
  const parsed = queryString.parse(window.location.search);
  navigateTo(
    `/${RouteNames.CREATE_CLAIM}?${queryString.stringify({
      ...parsed,
      ...extarProps,
      step,
    })}`
  );
};

export const getOptionValue = (id, type) => {
  const options = coreStore.getState().user.claimOptions;
  if (type && options[type]) {
    const option = options[type].find((item) => +item.id === +id);
    return {
      id: option?.id,
      name: option?.name,
    };
  }
  return {};
};
